const DefaultSkeletonCount = 100;

export default DefaultSkeletonCount;
